/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import TypesOfObjects from "pages/References/TypesOfOobjects/TypesOfObjects";
export default TypesOfObjects;
